import { useAPIGetProfileToolkitById } from 'api/profile/useAPIProfile'

const DEFAULT_PAGE_SIZE = 10

export const usePerangkatAjar = (userId: string, category: string) => {
  const { data, fetchNextPage, hasNextPage, isLoading } =
    useAPIGetProfileToolkitById(userId, category, {
      offset: 0,
      limit: DEFAULT_PAGE_SIZE,
    })

  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    meta: data?.pages.flatMap((page) => page.meta) ?? [],
    fetchNextPage,
    hasNextPage,
    isLoading,
  }
}
